import { render, staticRenderFns } from "./PurchaseDeliveryMailModalContent.vue?vue&type=template&id=8f1c473e"
import script from "./PurchaseDeliveryMailModalContent.vue?vue&type=script&lang=js"
export * from "./PurchaseDeliveryMailModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports